import { ContactUsFacadeService } from './../../../_app_modules/contact-us/desktop-contact-us/contact-us-facade.service';
import { filter, map, startWith } from 'rxjs/operators';
import { Observable, combineLatest } from 'rxjs';
import {
    ChangeDetectionStrategy,
    Component,
    ViewEncapsulation,
    OnInit
} from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { Subject } from './responsive-contact-us.types';
import { UntypedFormGroup } from '@angular/forms';
import { EntityLookupItemDto } from '@feature/pma-entity/pma-entity-types';
import * as lodash from 'lodash';

@Component({
    selector: "contact-us-dialog",
    templateUrl: "./responsive-contact-us-dialog.component.html",
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ResponsiveContactUsDialogComponent implements OnInit {
    selectedSubject: Subject;
    selectedAddress: EntityLookupItemDto;
    emailAddress: string;
    formGroup: UntypedFormGroup;
    selectedImages: File[] = [];
    successfullySent = false;
    failedToSend = false;

    form$: Observable<UntypedFormGroup>;
    subjects$: Observable<Subject[]> = this.contactUsFacadeService.subjects$;
    entities$: Observable<EntityLookupItemDto[]> = this.contactUsFacadeService.units$;
    filteredTenants$: Observable<EntityLookupItemDto[]> = this.contactUsFacadeService.tenantSuggestions$;
    filteredUnits$: Observable<EntityLookupItemDto[]> = this.contactUsFacadeService.unitSuggestions$;
    canSubmit$: Observable<boolean> = this.contactUsFacadeService.canSubmit$;
    displayAutocomplete$: Observable<boolean> = this.contactUsFacadeService.displayAutocompletes$;

    constructor(
        public dialogRef: MatDialogRef<ResponsiveContactUsDialogComponent>,
        private readonly contactUsFacadeService: ContactUsFacadeService,
    ) {
    }

    addressValueFunc = (address: EntityLookupItemDto) => address.Key;
    addressNameFunc = (address: EntityLookupItemDto) => address.Name;
    subjectValueFunc = (subject: Subject) => subject.Uri;
    subjectNameFunc = (subject: Subject) => subject.Subject;

    autoCompleteDisplayFn = (option) => option != undefined ? option.Name : '';

    ngOnInit(): void {
        this.form$ = this.contactUsFacadeService.form$;

        this.form$.subscribe((form) => {
            this.formGroup = form;
            if (form.controls.Entity) {
                combineLatest([this.displayAutocomplete$, form.controls.Entity.valueChanges]).pipe(
                    filter(([displayAutocomplete, value]) => displayAutocomplete),
                    map(([displayAutocomplete, value]) => value),
                    startWith(''),
                ).subscribe((value) => {
                    if (typeof value === 'string') {
                        this.contactUsFacadeService.callerAutoCompleteChange(value);
                    }
                    if (typeof value === 'object') {
                        this.contactUsFacadeService.callerAutoCompleteChange(value.Name);
                        this.contactUsFacadeService.selectCaller(value.Key);
                    }
                });
            }

            if (form.controls.Unit) {
                combineLatest([this.displayAutocomplete$, form.controls.Unit.valueChanges]).pipe(
                    filter(([displayAutocomplete, value]) => displayAutocomplete),
                    map(([displayAutocomplete, value]) => value),
                    startWith(''),
                ).subscribe((value) => {
                    if (typeof value === 'string') {
                        this.contactUsFacadeService.unitAutoCompleteChange(value);
                    }
                    if (typeof value === 'object') {
                        this.contactUsFacadeService.unitAutoCompleteChange(value.Name);
                        this.contactUsFacadeService.selectUnit(value.Key);
                    }
                });
            }
        });

    }

    private tenantOnChange(){
        this.contactUsFacadeService.selectCaller(null);
    }

    private unitOnChange(){
        this.contactUsFacadeService.selectUnit(null);
    }

    /**
     * 
     * @param files 
     */
    uploadImage(files: FileList) {
        const fileArray = Array.from(files);
        fileArray.forEach(file => {
            this.selectedImages.push(file);
        });
    }

    /**
     * 
     * @param selectedImage 
     */
    clearImage(selectedImage: File) {
        const index = this.selectedImages.indexOf(selectedImage, 0);
        if (index > -1) {
            this.selectedImages.splice(index, 1);
        }
    }

    /**
     * Function required to compare objects for angular material select
     * @param o1 
     * @param o2 
     * @returns 
     */
    compareFunc(o1: any, o2: any): boolean {
        return lodash.isEqual(o1, o2);
    }

    cancel() {
        this.contactUsFacadeService.cancel();
    }
    /**
     * 
     */
    send() {
        this.contactUsFacadeService.submit(this.selectedImages);
    }

}
